// extracted by mini-css-extract-plugin
export var copyright = "style-module--copyright--ba4c9";
export var header = "style-module--header--94f77";
export var icon = "style-module--icon--41622";
export var noRule = "style-module--noRule--0df27";
export var rule = "style-module--rule--30afe";